<template>
  <form @submit.prevent="submit()" v-bind="{...$attrs,...$props}" v-focusableNextElement="target == 'cordova'" @scroll="$emit('scroll', $event)" :class="classForm">
    <slot name="before" :rform="self"></slot>
    <div :class="classContent">
      <slot :rform="self"></slot>
    </div>
    <slot name="after" :rform="self"></slot>
  </form>
</template>
<script>

import Utils from "../js/Utils";
import DateUtils from "../js/DateUtils";
import { EventBus } from "../js/EventBus";
import preloaderDeLaSesion from "../js/utils/preloaderDeLaSesion.js";
import cerrojoDeLaSesion from "../js/utils/cerrojoDeLaSesion.js";
import { atarALaSesion } from "../js/utils/sesionDePeticiones.js";

export default {
  data() {
    return {
      self: this,
      target: process.env.TARGET,
      formData: { ...this.getFilterFromLocalStorage(), ...this.defaultData, ...this.initialData },
      errors: {},
      filterConfig: {},
      validateFields: {}, // Igual que validationFields pero se usa desde fuera (rInput)
      history: {},
      historyBulk: [],
      inspeccionInicial: null,
      dateRef: undefined,
      username: Utils.getUser()?.username,
      user: Utils.getUser(),
      canShowHistory: false,
      loadingHistory: false,
      isSaving: false,
    };
  },
  props: {
    classContent: {},
    classForm: {},
    dbAdapter: {
      type: Object
    },
    itemId: String,
    defaultData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    initialData: {
      type: Object,
      default: function() {
        return {};
      }
    },
    validationMessage: {
      type: String,
      default: "Revise los datos inválidos"
    },
    validationFields: {
      type: Object,
      default: function() {
        return {};
      }
      // Ejemplo de validationFields
      // {
      //  dni: {isValid: DNI.isValid, errorMessage: "* Introduzca un DNI válido"},
      //  iban: {isValid: IBAN.isValid, errorMessage: "* Introduzca un IBAN válido"}
      // }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    hidePreloaderOnSave: {
      type: Boolean,
      default: true
    },
    beforeSave: {
      type: Function,
      default: function(data, resolve, reject) {
        resolve(data);
      }
    },
    filtersName: String,
    documentoAdapter: {
      type: Object
    },
    uploadDocuments: {
      type: Function,
      default: function(data, documentoAdapter) {
        var self = this;
        var iterate = function(uploads, input, parent, key) {
          if (Array.isArray(input)) {
            input.forEach(function(el, idx) {
              iterate(uploads, el, input, idx);
            });
          } else if (typeof input === "object" && input !== null) {
            if (input._base64 && documentoAdapter) {
              uploads.push(
                new Promise(function(resolve, reject) {
                  var params = {
                    nombre: input.nombre,
                    extension: input.extension,
                    conservarNombre: input.conservarNombre,
                    sobrescribir: input.sobrescribir,
                    path: input.path,
                    offlinePath: input.offlinePath,
                    base64: input._base64,
                    tipo: input.tipo,
                    comentario: input.comentario,
                    selected: input.selected
                  };
                  self.documentoAdapter.uploadData(params)
                    .then(function(res) {
                      //Sustituir campos
                      parent[key] = res.list ? res.list[0] : res;
                      resolve();
                    })
                    .catch(function(e) {
                      reject(e);
                    });
                })
              );
            } else {
              for (let el in input) {
                iterate(uploads, input[el], input, el);
              }
            }
          }
          return uploads;
        };
        return new Promise(function(resolve, reject) {
          var uploads = iterate([], data);
          Promise.all(uploads).then( _ => {
              resolve(data);
            }).catch(e => reject(e));
        });
      }
    },
  },
  mounted() {
    var self = this;
    if (self.itemId) {
      self.loadItem(self.itemId);
    }
    self.$emit('mounted');
  },
  methods: {
    loadFilters: function(filters) {
      const self = this;
      self.clear();
      self.formData = { ...filters, ...self.formData };
    },
    addInList(name, value) {
      const self = this;
      if (self.formData[name] === undefined) {
        self.formData[name] = [];
      }
      self.formData[name].push(value);
    },
    removeFromList(name, value) {
      const self = this;
      if (self.formData[name] === undefined) {
        self.formData[name] = [];
      }
      self.formData[name] = self.formData[name].filter(function(item) {
        return item !== value;
      });
    },
    getValue: function(name) {
      var self = this;
      var namespaces = name.split(".");
      var context = self.formData;
      for (var i = 0; i < namespaces.length; i++) {
        if (typeof context == "undefined") {
          let n = namespaces[i];
          if (0 === n % (!isNaN(parseFloat(n)) && 0 <= ~~n)) {
            //Número entero positivo
            context = [];
          } else {
            context = {};
          }
        }
        if (typeof context == "undefined" || context == null) context = {};
        context = context[namespaces[i]];
      }
      if (this.$attrs && this.$attrs.multiple && context && context != null && context.indexOf(",") > -1) {
        context = context.split(",");
      }
      if (this.type == "datepicker") {
        if (context) {
          var previousVal = context;
          if (typeof context == "string") {
            context = new Date(previousVal);
            if (isNaN(context.getTime())) {
              var dateParts = previousVal.split("/");
              // month is 0-based, that's why we need dataParts[1] - 1
              context = new Date(dateParts[2], dateParts[1] - 1, + dateParts[0]); 
            }
          }
          context = [context];
        } else {
          context = [];
        }
      }
      return context;
    },
    submit: function() {
      const self = this;
      self.onSubmit(self.getFilter());
    },
    onSubmit: function(filters) {
      var self = this;
      self.saveFilterToLocalStorage(filters);
      self.$emit('submit', filters);
    },
    saveFilterToLocalStorage: function(filters) {
      var self = this;
      if (self.filtersName) {
        localStorage.setItem("filter-" + self.filtersName, JSON.stringify(filters));
      }
    },
    getFilterFromLocalStorage: function() {
      var self = this;
      var objReturn = {};
      if (self.filtersName) {
        objReturn = localStorage.getItem("filter-" + self.filtersName);
      }
      if (objReturn && typeof objReturn == "string") {
        try {
          objReturn = JSON.parse(objReturn);
        } catch (e) {
          objReturn = {};
        }
      }
      return objReturn || {};
    },
    validate: function(data) {
      var self = this;
      return new Promise(function(resolve, reject) {
        var error = {message: self.validationMessage};
        error.errors = {};
        const fields = Object.assign({}, self.validationFields, self.validateFields);
        for (const key in fields) {
          if (fields.hasOwnProperty(key)) {
            const element = fields[key];
            if (!element.isValid(self.getValue(key) || "")) {
              var obj = {};
              obj[key] = element.errorMessage;
              error.errors = Object.assign({}, error.errors, obj);
            }
          }
        }
        if (Object.keys(error.errors).length > 0) {
          reject(error);
        } else {
          resolve(data);
        }
      });
    },
    beforeSaveFn: function() {
      var self = this;
      return new Promise(self.beforeSave.bind(self, self.formData));
    },
    loadItem: function(itemId) {
      var self = this;
      var app = self.$f7;
      if (self.dbAdapter) {
        // #663 · Las esperas de este formulario son de la sesión (`preloaderDeLaSesion`): si cambia
        // en vuelo, la frontera calla el `then` que las apagaba y el indicador global se quedaba
        // encima del acceso. Los cerrojos, por lo mismo, con `cerrojoDeLaSesion`.
        const espera = preloaderDeLaSesion(self);
        espera.mostrar();
        self.dbAdapter
          .get({ itemId })
          .then(function(res) {
            self.formData = { ...self.defaultData, ...res };
            self.$emit("loadItem", res);
            self.inspeccionInicial = JSON.parse(JSON.stringify(res));
            self.hasHistory(itemId);
          })
          .catch(function(e) {
            console.log(e);
            app.dialog.alert(e.message);
            self.$emit("errorLoading", e.message);
          })
          .then(function() {
            espera.cerrar();
          });
      } else {
        self.$emit("loadItem", self.formData);
      }

    },
    collectChanges: function (nuevoObj, anteriorObj, id, date, username, punto, esOffline, v_doc, pathPrefix, changesMap) {
      const self = this;
      if (typeof nuevoObj !== 'object' || nuevoObj === null) {
        return;
      }
      
      // Obtener todas las claves tanto de nuevo como de anterior para no perder cambios
      const keysToProcess = new Set();
      if (typeof nuevoObj === 'object' && nuevoObj !== null) {
        Object.keys(nuevoObj).forEach(k => keysToProcess.add(k));
      }
      if (typeof anteriorObj === 'object' && anteriorObj !== null) {
        Object.keys(anteriorObj).forEach(k => keysToProcess.add(k));
      }
      
      for (let key of keysToProcess) {
        let newValue = nuevoObj[key];
        let oldValue = anteriorObj ? anteriorObj[key] : undefined;
        let fullPath = pathPrefix ? `${pathPrefix}.${key}` : key;

        if (typeof newValue === 'object' && newValue !== null && !(newValue instanceof Date)) {
          // Si es un array, iterar por cada elemento
          if (Array.isArray(newValue)) {
            for (let idx = 0; idx < newValue.length; idx++) {
              let arrayFullPath = `${fullPath}.${idx}`;
              let arrayNewValue = newValue[idx];
              let arrayOldValue = (oldValue && oldValue[idx]) ? oldValue[idx] : undefined;
              
              if (typeof arrayNewValue === 'object' && arrayNewValue !== null && !(arrayNewValue instanceof Date)) {
                // Recursivamente manejar objetos dentro del array
                self.collectChanges(arrayNewValue, arrayOldValue, id, date, username, punto, esOffline, v_doc, arrayFullPath, changesMap);
              } else {
                // Solo registrar si hubo cambio
                if (arrayNewValue !== arrayOldValue) {
                  // Nodo hoja dentro del array, registrar el cambio
                  if (!changesMap[arrayFullPath]) {
                    changesMap[arrayFullPath] = [];
                  }
                  changesMap[arrayFullPath].push({
                    valor: arrayNewValue,
                    id: id,
                    date: date,
                    username: username,
                    punto: punto,
                    esOffline: esOffline,
                    v_doc: v_doc,
                    valorAnterior: arrayOldValue
                  });
                }
              }
            }
          } else {
            // Recursivamente manejar objetos anidados (no arrays)
            self.collectChanges(newValue, oldValue, id, date, username, punto, esOffline, v_doc, fullPath, changesMap);
          }
        } else {
          // Solo registrar si hubo cambio
          if (newValue !== oldValue) {
            // Nodo hoja, registrar el cambio
            if (!changesMap[fullPath]) {
              changesMap[fullPath] = [];
            }
            changesMap[fullPath].push({
              valor: newValue,
              id: id,
              date: date,
              username: username,
              punto: punto,
              esOffline: esOffline,
              v_doc: v_doc,
              valorAnterior: oldValue
            });
          }
        }
      }
    },
    getHistory: function() {
      var self = this;
      var app = self.$f7;
      if (!self.dbAdapter || !self.dbAdapter.getHistory || !self.itemId) {return;}
      else {
        cerrojoDeLaSesion(self, 'loadingHistory');
        self.dbAdapter.getHistory({ itemId: self.itemId }, false)
          .then(function(res) {
            if (res && res.list && res.list.length > 0) {
              // vamos a ir añadiendo junto a cada atributo del pedido un atributo con el histórico <nombre atributo>History
              let historico = res.list;
              self.historyBulk = historico;
              let changesMap = {};
              historico.forEach(function (record) {
                let id = record.id;
                let date = record.date;
                let username = record.username;
                let punto = record.punto;
                let esOffline = record.esOffline;
                let v_doc = record.v_doc;
                let nuevo = record.nuevo || {};
                let anterior = record.anterior || {};
                self.collectChanges(nuevo, anterior, id, date, username, punto, esOffline, v_doc, '', changesMap);
              });
              self.history = changesMap;
              if(self.history) {
                let entity = self.formData;
                Object.keys(self.history).forEach(function(key) {
                  self.history[key] = self.history[key].sort((a, b) => { return new Date(b.date) - new Date(a.date); })
                });
              }
            }
            self.loadingHistory = false;
          })
          .catch(function(err) {
            self.loadingHistory = false;
          })
          .catch(function(error) {
            if(error.status && error.status == 404) {
              console.log("error 404 URL: " + error.url);
            } else {
              app.dialog.alert(error.message);
            }
          });
      }
    },
    hasHistory: function() {
      var self = this;
      var app = self.$f7;
      if (!self.dbAdapter || !self.dbAdapter.hasHistory) {return;}
      else {
        self.dbAdapter.hasHistory(false)
          .then(function(res) {
            self.canShowHistory = !!res;
          })
          .catch(function (error) {
            self.canShowHistory = false;
            console.log("Error checking history availability: ", error);
          });
      }
    },
    cancelEdit() {
      const self = this;
      self.formData = JSON.parse(JSON.stringify(self.inspeccionInicial));
    },
    saveItem(afterSaveFunction) {
      var self = this;
      var app = self.$f7;
      
      // Prevenir guardados concurrentes
      if (self.isSaving) {
        console.warn('Ya hay un guardado en progreso, ignorando guardado concurrente');
        return Promise.resolve();
      }
      
      // Si la sesión cambia en vuelo, el `then` del final que lo suelta no corre, y con este
      // formulario en una ruta `keepAlive` ningún guardado más pasaría de la guarda de arriba.
      cerrojoDeLaSesion(self, 'isSaving');
      
      // Guardar una copia profunda del estado anterior ANTES de procesar
      // Esto asegura que DeepDiff capture correctamente los cambios
      const previousDataSnapshot = JSON.parse(JSON.stringify(self.inspeccionInicial));
      
      // La espera es del formulario y la suelta él siempre, al final. Con `hidePreloaderOnSave`
      // a `false` antes la dejaba puesta para que la apagara el padre con un `hide()` global; ahora
      // el padre que siga trabajando tras `save` enciende la suya al recibirlo —antes de que esta se
      // suelte, así que el indicador no parpadea— y suelta solo ésa. Un testigo que se quedara
      // esperando un `hide()` del padre no lo soltaría nadie, y ya no se apagaría en toda la sesión.
      const espera = preloaderDeLaSesion(self);
      if (!self.formData.guardadoSilencioso) {
        espera.mostrar();
      }
      // La cadena se ata a la sesión desde su cabeza: `beforeSaveFn` devuelve una `Promise`
      // nativa, y adoptar luego la del adaptador no protege lo que cuelga de ella. Sin atar, cerrar
      // sesión con el guardado en vuelo pintaba el `alert` vacío de la cancelación y emitía
      // `error` y `guardadoTerminado` en la sesión siguiente; y si cambiaba durante `beforeSave`,
      // llegaba a lanzar el `save` con los datos de la cuenta anterior.
      atarALaSesion(self.beforeSaveFn())
        .then(res => self.validate(res))
        .then(res => self.uploadDocuments(res, self.documentoAdapter))
        .then(function(data) {
          const currentDataSnapshot = JSON.parse(JSON.stringify(data));
          if (self.dbAdapter) {
            return self.dbAdapter.save({
              data: currentDataSnapshot,
              itemId: self.itemId,
              previousData: previousDataSnapshot
            });
          } else {
            return new Promise(function(resolve, reject) {
              resolve(currentDataSnapshot);
            });
          }
        })
        .then(function(res) {
          self.errors = {};
          self.inspeccionInicial = JSON.parse(JSON.stringify(res));
          self.$emit("save", res, afterSaveFunction);
          
          // Emitir evento en EventBus para componentes externos
          EventBus.$emit('tarea-guardada', res);
          
          // if(self.itemId) self.getHistory(self.itemId);
        })
        .catch(function (e) {
          Utils.log("[rform] Error al guardar: " + e);
          console.log(e);
          if (e &&  e.code == 'ERROR_AUDITORIA') {
            var message = e.message + " :<ul>";
            e.errors.forEach( err => {message+= "<li>"+err+"</li>";})
            message+="</ul>";
            app.dialog.alert(message);
            return;
          }
          if (typeof e == "string") {
            e = {
              message: e
            };
          }
          // Un `beforeSave` puede cancelar el guardado por algo que la persona acaba de decidir y
          // ya tiene delante —el aviso de planificaciones abiertas de la #425 al irse al
          // calendario—. Ahí el diálogo no informa: aterriza encima de la pantalla a la que se ha
          // navegado. El guardado queda cancelado igual, e `isSaving` se suelta abajo como siempre.
          if (e && e.cancelacionSilenciosa) {
            return;
          }
          app.dialog.alert(e ? e.message : "Error no identificado");
          self.errors = e.errors || {};
          self.$emit("error", e);
        })
        .then(function() {
          espera.cerrar();
          self.isSaving = false;
          // El final del guardado, salga como salga: el `catch` de arriba no emite `error` en todos
          // los casos (auditoría, cancelación silenciosa), y quien encendió su propia espera para
          // un guardado silencioso no tenía otra señal para soltarla. Antes lo hacía el `hide()`
          // global de esta misma línea.
          self.$emit("guardadoTerminado");
        });
    },
    deleteItem: function() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        "Eliminar",
        function() {
          if (self.dbAdapter) {
            self.dbAdapter.delete({itemId: self.itemId}).then(function(res) {
              if (res) {
                app.toast
                  .create({
                    icon: '<i class="f7-icons">checkmark</i>',
                    text: self.$t("rlist.registro_eliminado"),
                    position: "center",
                    destroyOnClose: true,
                    closeTimeout: 2000
                  })
                  .open();
                self.$emit("deleteItem");
                self.$f7router.back()
              }
            }).catch(function(error){
              app.dialog.alert(error.message);
            });
          } else {	
            self.$emit("deleteItem");	
          }
        }
      );
    },
    clear: function() {
      var self = this;
      //self.$set(self, 'formData', {});
      self.formData = { ...{}, ...this.defaultData};
      return;
    },
    getFilter: function() {
      var self = this;
      //var res = [];
      var res = {};
      for (let f in self.formData) {
        let d = self.formData[f];
        let fc = self.filterConfig[f] || {};
        res[f] = d;
        // if (d && typeof d === "object" && d.constructor == Object) {
        //   // M2o
        //   let searchField = fc.searchField || "id";
        //   //let operation = fc.operation || "=";
        //   if (!d[searchField]) continue;
        //   //res.push([f + "." + searchField, operation, d[searchField]]);
        //   res[f] = d[searchField];
        // } else {
        // // if ((d && typeof d === "string") || d instanceof String) {
        //   //let operation = fc.operation || "%LIKE%";
        //   //res.push([f, operation, d]);
        //   res[f] = d;
        // }
      }
      return res;
    }
  }
};
</script>
